import React, { useState } from 'react';
import { useTable, useSortBy, usePagination, useFilters } from 'react-table';
import { trans, setCommaDateFormat } from '../helpers';
import Select from 'react-select';

function CellContent({ cell, params }){

    if ( cell.column.hasOwnProperty('ctnList') ) {
        const ctnList = cell.value.split(',');
        const ctnListCount = ctnList.length;
        const ctnListShowCount = 3;

        let ctnResult = ctnList.map( ( item, index ) => index < ctnListShowCount ? <p key={index} className="filter__ctn no-wrap">{item}</p> : null);

        if ( ctnListCount > ctnListShowCount ) {
            ctnResult.push(<p className="filter__ctn-more" key={ctnListCount}>{trans( params.b2bTrans, 'b2b.application.table.app_ctn_more_txt' ).replace(/%s/, ctnListCount - ctnListShowCount)}</p>);
        }

        return <>{ctnResult}</>;
    }

    if ( cell.column.hasOwnProperty('attachedFile') ) {

        let attachedFile = <div className="filter__empty-line ver-middle-box">&nbsp;</div>;

        if ( cell.value !== '' ) {
            attachedFile = <div className="filter__attached sprite">&nbsp;</div>;
        }

        return attachedFile;
    }

    if ( cell.column.hasOwnProperty('editElem') ) {
        return cell.column.params.toEdit( cell.row.original.id );
    }

    if ( cell.column.id === 'updated_at' ) {
        return setCommaDateFormat( cell.value );
    }

    if ( cell.column.id === 'application_priority' ) {
        return trans( params.b2bTrans, 'b2b.application.priority_' + cell.value );
    }

    if ( cell.column.id === 'application_status' ) {
        return trans( params.b2bTrans, 'b2b.application.status_' + cell.value );
    }

    if ( cell.column.id === 'application_type.current.title' && typeof cell.value === 'undefined' ) {
        return trans(params.b2bTrans, 'b2b.application.new_tp_title');
    }

    return cell.render('Cell');

}

/*
function getPaging( pageIndex, pageCount, pagingAverage = 2 ) {

    let start = pageIndex - pagingAverage,
        end = pageIndex + pagingAverage,
        paging = [];

    if ( start < 1 ) {
        start = 1;
    }

    if ( end > pageCount-1 ) {
        end = pageCount;
    }

    for ( ; start <= end; start++ ) {
        paging.push( start );
    }

    return paging;

}
 */

function Table({ columns, data, params }) {

    const defOptions = [{
        label: trans( params.b2bTrans, 'b2b.application.table.show_5' ),
        value: 5
    },{
        label: trans( params.b2bTrans, 'b2b.application.table.show_10' ),
        value: 10
    },{
        label: trans( params.b2bTrans, 'b2b.application.table.show_25' ),
        value: 25
    },{
        label: trans( params.b2bTrans, 'b2b.application.table.show_50' ),
        value: 50
    },{
        label: trans( params.b2bTrans, 'b2b.application.table.show_100' ),
        value: 100
    }];
    const [option, setOption] = useState(defOptions[0]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        gotoPage,
        pageCount,
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage
    } = useTable(
        {
            columns,
            data,
            initialState: { pageSize: 5 }
        },
        useFilters,
        useSortBy,
        usePagination
    );

    return (
        <div className="filter">
            <div className="filter__content scroller-block">
                <table className="filter__table filter__table--valign-middle" {...getTableProps()}>
                    <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                // Add the sorting props to control sorting. For this example
                                // we can add them into the header props
                                <th {...column.getHeaderProps([
                                    {
                                        title: column.Header,
                                        className: column.colClassName + ( column.isSorted ? column.isSortedDesc ? ' filter__order--desc' : ' filter__order--asc' : '' )
                                    },
                                    column.sort && column.getSortByToggleProps()
                                ])}>{column.render('Header')}</th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map(
                        (row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps(( state, rowInfo ) => {

                                    if (
                                        ( params.curator === '' && Number( rowInfo.row.values.application_status ) === 3 ) ||
                                        ( params.curator === 'curator' && rowInfo.row.original.application_admin_reply_status === '1' && rowInfo.row.original.application_curator_reply_status === '0' )
                                    ) {
                                        state.className = 'filter__row-active';
                                    }
                                        return state;
                                    })}>
                                    {row.cells.map(cell => {
                                        return (
                                            <td {...cell.getCellProps(( cellInfo ) => {
                                                cellInfo.className = cell.column.cellClassName;
                                                return cellInfo;
                                            })}><CellContent
                                                cell={cell}
                                                params={params}
                                            /></td>
                                        )
                                    })}
                                </tr>
                            )}
                    )}
                    </tbody>
                </table>
            </div>

            <div className="filter__paging tr">
                {
                    pageCount !== 1 ?
                        <ul className="filter__paging-list ver-top-box">
                            <li className="filter__paging-item filter__paging-item--btn-box ver-top-box">
                                <button className="filter__paging-btn filter__paging-btn--first" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>&lt;&lt;</button>
                            </li>
                            <li className="filter__paging-item filter__paging-item--btn-box ver-top-box">
                                <button className="filter__paging-btn filter__paging-btn--prev" onClick={() => previousPage()} disabled={!canPreviousPage}>&lt;</button>
                            </li>
                            {
                                [-2, -1, 0, 1, 2].map(( item, index ) => {

                                    const pageItem = ( pageIndex + 1 ) + item;

                                    if ( pageItem < 1 || pageItem > pageCount ) {
                                        return undefined;
                                    }

                                    return <li className={`filter__paging-item ver-top-box fs14${(pageIndex + 1) === pageItem ? ' filter__paging-item--active' : ''}`} key={index} onClick={() => gotoPage(pageItem-1)}>{pageItem}</li>;
                                })
                            }
                            <li className="filter__paging-item filter__paging-item--btn-box ver-top-box">
                                <button className="filter__paging-btn filter__paging-btn--next" onClick={() => nextPage()} disabled={!canNextPage}>&gt;</button>
                            </li>
                            <li className="filter__paging-item filter__paging-item--btn-box ver-top-box">
                                <button className="filter__paging-btn filter__paging-btn--last" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>&gt;&gt;</button>
                            </li>
                        </ul> : ''
                }
                <div className="filter__paging-counts fs14 ver-top-box">{trans( params.b2bTrans, 'b2b.application.table.paging_per_page' )} <em>{pageIndex + 1} {trans( params.b2bTrans, 'b2b.application.table.paging_per_page_of' )} {pageOptions.length}</em></div>
                {
                    pageCount !== 1 ?
                        <div className="filter__paging-go-to fs14 ver-top-box">
                            {trans( params.b2bTrans, 'b2b.application.table.paging_go_to' )}
                            <input
                                className="filter__paging-field fs14 tc"
                                type="text"
                                defaultValue={pageIndex + 1 || 1}
                                onChange={e => gotoPage( e.target.value ? Number(e.target.value) - 1 : 0 )}
                            />
                        </div> : ''
                }
                <div className="filter__paging-select-box fs14 ver-top-box pr tl">
                    <Select
                        options={defOptions}
                        value={option}
                        onChange={( option ) => {
                            setOption( option );
                            setPageSize( option.value );
                        }}
                        placeholder={trans( params.b2bTrans, 'b2b.application.table.select_default_label' )}
                        noOptionsMessage={() => trans( params.b2bTrans, 'b2b.application.table.select_no_options_message' )}
                    />
                </div>
            </div>

        </div>
    )
}

function TableHook({ data, params }){

    const columns = [
        {
            Header: trans( params.b2bTrans, 'b2b.application.table.app_id' ),
            accessor: 'id',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: 'fs14 no-wrap filter__circle',
            sort: true,
            showStatusCircle: true
        },
        {
            Header: trans( params.b2bTrans, 'b2b.application.table.app_date' ),
            accessor: 'updated_at',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: 'fs14',
            sort: true
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_creator_email' ),
            accessor: 'creator.email',
            colClassName: 'fs12',
            cellClassName: 'fs14',
            sort: false
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_creator_inn' ),
            accessor: 'creator.inn',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: '',
            sort: false
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_ctn' ),
            accessor: 'ctn',
            colClassName: 'fs12',
            cellClassName: 'fs14',
            sort: false,
            ctnList: true
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_type' ),
            accessor: 'application_type.current.title',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: 'fs14',
            sort: true
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_status' ),
            accessor: 'application_status',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: 'fs14',
            sort: true,
            checkForStatus: true
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_priority' ),
            accessor: 'application_priority',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: 'fs14',
            sort: true
        },{
            Header: trans( params.b2bTrans, 'b2b.application.table.app_attached' ),
            accessor: 'application_file',
            colClassName: 'filter__order fs12 sprite-a no-wrap',
            cellClassName: 'fs14',
            sort: true,
            attachedFile: true
        },{
            Header: '',
            accessor: 'empty',
            colClassName: '',
            cellClassName: '',
            sort: false,
            editElem: true,
            params
        }
    ];

    const memoData = React.useMemo(() => data, []);

    return (
        <Table
            columns={columns}
            data={memoData}
            params={params}
        />
    )

}

export default TableHook;
